// NPM Imports
import React, { Suspense } from "react";
import { useSelector } from "react-redux";

// Components Imports
import MetaField from "../MetaField";
import Notes from "../Notes";
import Catalog from "../Catalog";
import GoogleCatalog from "../GoogleCatalog";
import ExcelCatalog from "../ExcelCatalog";
import Collaborators from "../Collaborators";
// import DocumentDetails from "../DocumentDetails";
import AttachmentComponent from "../AttachmentComponent/AttachmentComponent";
import AttachmentComponentUpgrade from "../AttachmentComponent/AttachmentComponentUpgrade";

import DocumentSettings from "../DocumentSettings";
import QuickReview from "../QuickReview";
import Activity from "../Activity";
import { LazyLoad, FeatureGating } from "../../commonComponents";

// Internal Imports
import { TOOLPANE, FEATURES } from "../../constants";
import DocumentDetails from "../DocumentDetails";
import TemplateDetailsGlobal from "../TemplateDetailsGlobal";
import LZLoader from "../../commonComponents/LZLoader";

// Loazy laod components
const DocumentComponentsLazy = LazyLoad(() =>
  import(/* webpackChunkName: "document-components" */ "../DocumentComponents"),
);
const DynamicFieldLazy = LazyLoad(() =>
  import(
    /* webpackChunkName: "dynamic-field-page" */ "../Document/DynamicField"
  ),
);
const DocSignatureListPaneLazy = LazyLoad(() =>
  import(
    /* webpackChunkName: "doc-signature-list-pane" */ "../DocumentComponents/SignatureListPane/DocSignatureListPane"
  ),
);

const SignTagPropertiesPaneLazy = LazyLoad(() =>
  import(
    /* webpackChunkName: "sign-tag-properties-pane" */ "../DocumentComponents/SignatureListPane/SignTagPropertiesPane"
  ),
);

// Destructuring
const { FEATURES_NAME } = FEATURES;
const { TOOLPANE_TTITLE } = TOOLPANE;

export default function ToolPaneActiveView({
  coverpageThemeActionData,
  disableEdit,
  isSharedDocument,
  mode,
  sharingHash,
  signatureWrapperRef,
  view,
  templateLockStatus,
}) {
  // mapStateToProps
  const docId = useSelector(state => state.DocumentStore.document.id);
  const isLocked = useSelector(state => state.DocumentStore.document.isLocked);
  const clickedActiveComponentType = useSelector(
    state => state.DocumentStore.clickedActiveComponentType,
  );
  const addComponentType = useSelector(
    state => state.ToolPaneStore.addComponentType,
  );

  switch (view) {
    case TOOLPANE_TTITLE.CATALOG:
      return <Catalog />;
    case TOOLPANE_TTITLE.COLLABORATORS:
      return <Collaborators />;
    case TOOLPANE_TTITLE.NOTES:
      return (
        <Notes isSharedDocument={isSharedDocument} sharingHash={sharingHash} />
      );
    case TOOLPANE_TTITLE.DOCUMENT_DETAILS:
      return <DocumentDetails />;
    case TOOLPANE_TTITLE.TEMPLATE_DETAILS:
      return <TemplateDetailsGlobal />;
    case TOOLPANE_TTITLE.METAFIELD:
      return <MetaField mode={mode} />;
    case TOOLPANE_TTITLE.SETTINGS:
      return <DocumentSettings mode={mode} />;
    case TOOLPANE_TTITLE.DOC_COMPONENTS:
      if (
        !coverpageThemeActionData &&
        (!addComponentType ||
          addComponentType !== clickedActiveComponentType) &&
        disableEdit
      ) {
        return null;
      }
      return (
        <Suspense fallback={<LZLoader label="please wait..." largelabel />}>
          <DocumentComponentsLazy
            mode={mode}
            signatureWrapperRef={signatureWrapperRef}
          />
        </Suspense>
      );
    case TOOLPANE_TTITLE.DYNAMIC_FIELDS:
      return (
        <Suspense fallback={<LZLoader label="please wait..." largelabel />}>
          <DynamicFieldLazy isLocked={templateLockStatus} />
        </Suspense>
      );
    case TOOLPANE_TTITLE.ACTIVITY:
      return <Activity />;
    case TOOLPANE_TTITLE.GOOGLE_CATALOG:
      return (
        <GoogleCatalog
          isLocked={templateLockStatus}
          docId={docId}
          mode={mode}
        />
      );
    case TOOLPANE_TTITLE.EXCEL_CATALOG:
      return (
        <ExcelCatalog docId={docId} mode={mode} isLocked={templateLockStatus} />
      );
    case TOOLPANE_TTITLE.ATTACHMENTS:
      return (
        <FeatureGating
          name={FEATURES_NAME.DOCUMENT_ATTACHMENT}
          altComponent={
            <AttachmentComponentUpgrade
              isSharedDocument={isSharedDocument}
              sharingHash={sharingHash}
              docId={docId}
              featureName={FEATURES_NAME.DOCUMENT_ATTACHMENT}
            />
          }>
          <AttachmentComponent
            isSharedDocument={isSharedDocument}
            sharingHash={sharingHash}
            docId={docId}
          />
        </FeatureGating>
      );
    case TOOLPANE_TTITLE.QUICK_REVIEW:
      return <QuickReview isSharedDocument={isSharedDocument} docId={docId} />;
    case TOOLPANE_TTITLE.SIGNATURE_COMPONENTS:
      return (
        <Suspense fallback="">
          <DocSignatureListPaneLazy mode={mode} />
        </Suspense>
      );
    case TOOLPANE_TTITLE.DOC_SIGNATURE_COMPONENTS:
      return (
        !isLocked && (
          <Suspense fallback="">
            <DocSignatureListPaneLazy mode={mode} />
          </Suspense>
        )
      );
    case TOOLPANE_TTITLE.SIGN_TAG_PROPERTIES:
      return (
        !isLocked && (
          <Suspense fallback="">
            <SignTagPropertiesPaneLazy mode={mode} />
          </Suspense>
        )
      );
    default:
      return null;
  }
}
